import { TMBError as s, TMBErrorType as t } from "./error.js";
import { getServerInfo as o } from "../constants/urls.js";
const c = async () => {
  const { serverUrl: r } = o();
  try {
    return await (await fetch(`https://${r}/oauth2/sessions/active`, {
      method: "GET",
      credentials: "include"
    })).json();
  } catch (e) {
    throw console.error("unable to request sessions active: ", e), e instanceof Error ? new s(t.FailedFetchSessionsActive, e.message) : new s(t.FailedFetchSessionsActive, "unable to request sessions active");
  }
}, h = async () => {
  const { serverUrl: r } = o();
  try {
    return await (await fetch(`https://${r}/oauth2/sessions/refresh`, {
      method: "POST",
      credentials: "include"
    })).json();
  } catch (e) {
    throw console.error("unable to request sessions active: ", e), e instanceof Error ? new s(t.FailedFetchSessionsActive, e.message) : new s(t.FailedFetchSessionsActive, "unable to request sessions active");
  }
};
export {
  c as requestSessionActive,
  h as requestSessionRefresh
};
